<template lang="pug">
	img(:src="ruta", :style="estilo", class="rounded-circle", v-if="ruta")
</template>
<script>
export default {
	props: ['usuario', 'width', 'avatar'],
	data () {
		return {
			ruta: null,
			timestamp: null,
			estilo: {
				width: '50px',
				height: '50px'
			}
		}
	},
	created () {
		if (this.usuario) {
			this.timestamp = (this.avatar) ? this.avatar : new Date().getTime()
			this.ruta = '/src/modulos/core/php/api/perfil/avatar.php?avatar=avatar_' + this.usuario + '_' + this.timestamp

			if (this.width) {
				this.estilo = {
					width: this.width + 'px',
					height: this.width + 'px'
				}
			}
		} else {
			this.ruta = '/static/recursos/otro.svg'
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/common/avatar.vue